if (!customElements.get('quick-shop')) {
  class Quickshop extends HTMLElement {
    constructor() {
      super();

      // Variables
      this.productForm = this.querySelector('product-form');
      this.quantitySelector = this.querySelector('quantity-input input[name="quantity"]');

      this.formFields = {
        id: this.productForm.querySelector('input[name="id"]'),
        invertoryQuantity: this.productForm.querySelector('input[name="inventory_quantity"]'),
        quantity: this.productForm.querySelector('input[name="quantity"]')
      }


      // Bind option select events
      this.querySelectorAll('[data-quickshop-option]').forEach((option) =>
        option.addEventListener('click', () => {
           this.onOptionSelect(option.value, option.dataset.inventoryQuantity)
        })
      );


      this.quantitySelector?.addEventListener('change', (event) => {
        this.handleQuantityInput(event.target.value);
      });
    }

    /**
     * Adds a variant to the cart
     * @description Adds the clicked option/variant to the cart leveraging the product form component.
     * @param {String} variantId
     * @param {String} inventoryQuantity
     */
    onOptionSelect(variantId, inventoryQuantity) {
      this.formFields.id.value = variantId;
      this.formFields.invertoryQuantity.value = inventoryQuantity;
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput(quantity) {
      this.formFields.quantity.value = quantity;
    }

  }

  window.Quickshop = Quickshop;
  customElements.define('quick-shop', Quickshop);
}

